import { compose, lifecycle, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { path } from 'ramda'

import { requireQuestion } from '../../actions'

const mapStateToProps = state => ({
  rehydrate: path(['app', 'persist', 'rehydrate'], state)
})

function componentWillMount() {
  this.props.requireQuestion()
}

export default compose(
  withRouter,
  connect(mapStateToProps, { requireQuestion }),
  branch(({ rehydrate }) => !rehydrate, renderNothing),
  lifecycle({ componentWillMount })
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Main/enhancers.js